<mat-form-field appearance="fill" *ngIf="control" hideRequiredMarker>
    <mat-label
        >{{ placeholder }}
        <ng-container *ngIf="required"> *</ng-container>
    </mat-label>
    <input
        matInput
        [id]="id"
        [formControl]="control"
        [autocomplete]="autocomplete"
        [type]="type"
    />
    <span
        matSuffix
        *ngIf="icon"
        class="{{ icon }}"
        [matTooltip]="tooltip"
        [matTooltipDisabled]="!tooltip"
        [appTooltip]="true"
        click-stop-propagation
    ></span>
    <mat-error *ngIf="control.hasError('required')">
        {{ "ERRORS.FIELD_IS_REQUIRED" | translate }}
    </mat-error>
    <mat-error>
        <ng-content></ng-content>
    </mat-error>
    <mat-hint *ngIf="hint">
        {{ hint }}
    </mat-hint>
</mat-form-field>
